import React, { FC } from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import { IconButton } from '@mui/material';
import ContentLoader from 'react-content-loader';
import Theme from 'App.theme';
import useFileMetadata from './hook/useFileMetadata';
import * as Styles from './PdfPreview.styles';

interface PdfPreviewProps {
  file?: File;
  fileUrl?: string;
  deviceId: string;
  firebase?: boolean;
}

const PdfPreview: FC<PdfPreviewProps> = ({ firebase, file, fileUrl, deviceId, ...rest }) => {
  const fileMetadata = useFileMetadata(deviceId, firebase, file, fileUrl ?? '');

  const handleFileDownload = () => {
    if (fileMetadata.src) {
      const link = document.createElement('a');
      link.download = fileMetadata.fileData?.name ?? '';
      link.href = fileMetadata.src;
      link.target = '_blank';

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    }
  };

  if (fileMetadata.loading)
    return (
      <ContentLoader
        speed={2}
        width={300}
        height={250}
        backgroundColor={Theme.greys.GREY0}
        foregroundColor={Theme.greys.GREY1}
        {...rest}
      >
        <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
      </ContentLoader>
    );

  if (!fileMetadata.fileData) {
    return (
      <Styles.PdfPreviewContainer>
        <p>No file uploaded...</p>
      </Styles.PdfPreviewContainer>
    );
  }

  return (
    <Styles.PdfPreviewContainer {...rest}>
      <Styles.PdfPreviewContentContainer>
        <div>
          <DescriptionIcon sx={{ fontSize: 80 }} />
        </div>
        <Styles.PdfPreviewInfo>
          <p>
            <b>{fileMetadata.fileData?.name}</b>
          </p>
          <p>Uploaded: {fileMetadata.fileData?.lastModified.toLocaleDateString('en-GB')}</p>
        </Styles.PdfPreviewInfo>
        <IconButton onClick={handleFileDownload}>
          <DownloadIcon sx={{ fontSize: 80 }} />
        </IconButton>
      </Styles.PdfPreviewContentContainer>
    </Styles.PdfPreviewContainer>
  );
};

export default PdfPreview;
